<template>
  <v-app id="Gbmt3">
    <v-main>
      <v-container fluid>
      <v-row>
          <v-col cols="2">
            <v-select v-model="bedrCodesSelected" :items="bedrCodes" item-value="bedrCode"  item-text="bedrCode" label="Companies" multiple></v-select>
          </v-col>
          <v-col cols="2">
            <v-select v-model="param.typeCode" :items="param.typeCodes" item-value="typeCode"  item-text="typeCodeOms" label="Type of list"></v-select>
          </v-col>

      </v-row>
      <v-row>

          <v-col cols="2">
            <v-menu
              v-model="dat2menu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
            <template v-slot:activator="{ on }">
            <v-text-field
              v-model="param.tm_dat" 
              label="Until date"
              v-on="on"
              readonly
            ></v-text-field>
            </template>
            <v-date-picker v-model="param.tm_dat2" :first-day-of-week="1" @input="param.tm_dat = $moment(param.tm_dat2).format('DD-MM-YYYY'); dat2menu = false"></v-date-picker>
            </v-menu>  
          </v-col>

      </v-row>  

      <v-row>
          <v-col cols="2">
            <v-select v-model="gbrkCodesSelected" :items="gbrkCodes" item-value="gbrkCode"  item-text="gbrkCode" label="Ledger account"></v-select>
          </v-col>
      </v-row>
     

      <v-row>    
          <v-col cols="1">
            <v-btn class="primary ma-0" small :disabled="submitted||param.typeCode===''" @click="ovrz">Create excel</v-btn>
          </v-col> 
      </v-row>

    </v-container>
     <showProgress ref="showProgress"></showProgress>
    </v-main>
    <navBar :title="'Ares - Finance'" :home="true" type="finance"/>
  </v-app>
</template>

<script>
import navBar from "@/components/ui/navbars/navbar.vue";
import showProgress from "@/components/showProgress.vue";
 export default {
  components: {
    navBar,
    showProgress
  },
  data() {
    return {
      bedrCodesSelected: [],
      bedrCodes: [],
      gbrkCodesSelected: [],
      gbrkCodes: [],
      dat2menu: false,
      hulpDate: '',
      submitted: false,
      param: {
        typeCode: "",
      }
    }
  },
  created() {
    var deze = this;
      this.$axios
      .post("ares/json/ares/task/fin/ovrz/getGbmt3Param.p", {
        header: {
          token: this.$session.get("ARES"),
          clientSessionId: this.$session.id(),
          request: "getGbmt3Param"
        },
        getGbmt3Param: {}
      })
      .then(res => {
        if (res.data.error) {
          console.log(res.data.error);
        } else {
           this.param = res.data.getGbmt3Param; 
           res.data.getGbmt3Param.bedrKeuzes.forEach(function(bedr) {
             deze.bedrCodes.push(bedr.bedrCode);
             if (bedr.bedrSelected === true) {
                deze.bedrCodesSelected.push(bedr.bedrCode);
             }
           });
           res.data.getGbmt3Param.gbrkKeuzes.forEach(function(gbrk) {
             deze.gbrkCodes.push(gbrk.gbrkCode);
             if (gbrk.gbrkSelected === true) {
                deze.gbrkCodesSelected.push(gbrk.gbrkCode);
             }
           });
           
        }
      });

  },
  methods: {
     ovrz() {
      this.results = true;
      this.submitted = true;
      // this.$refs.showProgress.open();
      this.$axios
        .post("ares/json/ares/task/fin/ovrz/excelExportGbmt3.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "excelExportGbmt3"
          },
          excelExportGbmt3: {
            bedr_codes: this.bedrCodesSelected,
            gbrk_codes: this.gbrkCodesSelected,
            tm_dat: this.param.tm_dat,
            type_lijst_finance: this.param.typeCode,
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            //this.items = res.data.excelExportGbmt3;
            //this.$refs.showProgress.close();
            this.submitted = false;
            //window.open(this.items.filename,'_blank');
            this.$store.dispatch("setSnackbar", {
              showing: true,
              text: res.data.excelExportGbmt3.text,
              color: res.data.excelExportGbmt3.color,
            });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

  }
};

</script> 
